import { render, staticRenderFns } from "./ProductLink.vue?vue&type=template&id=e87d7b9c&"
import script from "./ProductLink.ts?vue&type=script&lang=ts&"
export * from "./ProductLink.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductLink.vue"
export default component.exports